{
    "mcpPermissions": {
        "menu": "MCP Tool Permissions",
        "title": "MCP Tool Permissions",
        "info": {
            "interim": "An empty allowlist currently grants ALL tools (interim policy). To actually restrict a user, keep at least one tool checked."
        },
        "column": {
            "permissions": "MCP Permissions"
        },
        "badge": {
            "unrestricted": "Unrestricted (all tools)"
        },
        "filter": {
            "tools": "Filter tools…"
        },
        "action": {
            "selectAll": "Check all",
            "clearAll": "Uncheck all"
        },
        "save": "Save",
        "loadError": "Failed to load tool permissions",
        "emptyWarn": {
            "header": "Empty allowlist grants ALL tools",
            "message": "These users would have an empty allowlist, which currently grants ALL tools (interim policy): {users}. To actually restrict them, keep at least one tool checked. Save anyway?",
            "accept": "Save anyway"
        },
        "dialog": {
            "title": "MCP permissions — {name}",
            "saved": "MCP permissions updated",
            "saveError": "Failed to update MCP permissions"
        }
    }
}
